define('modules/base/views/lazy.paging.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    "marionette",
    "modules/base/views/model.view"
], function(
    Prospector,
    $,_,Backbone,Marionette,
    ModelView
){
    var LazyPagingView = ModelView.extend({
        hasMoreAttr: 'hasMore',
        debugName: 'Lazy Paging View',
        noResultsTemplate: '<div class=""></div>',
        noFilterResultsTemplate: '<div class=""></div>',
        procModel:function(){
            this.removeLoader();
            if(this.model.has('error')){
                this.errOut(this.model.get('error').message);
                this.model.set({error: undefined});
            } else {
                this.addGetMoreView();
            }
        },
        procResponse:function(){

        },
        addGetMoreView:function(){
            this.getMoveView = this.getGetMoreView();
            if(this.getMoveView != null){
                this.getLoaderDiv().append(this.getMoveView.render().el);
                this.getMoveView.addLoader();
            }
            this.procResponse();
        },
        getMoreModels:function(){
            this.model.page++;
            this.model.once('sync', this.prependGetMore, this);
            if(this.abortable){
                if(this.currXHR != undefined && this.currXHR.readyState > 0 && this.currXHR.readyState < 4){
                    this.currXHR.abort();
                }
            }
            this.currXHR = this.model.fetch();
        },
        prependGetMore:function(){
            var newViews = this.getAdditionalViews();
            if(newViews.length > 0){
                _.each(newViews, function(view){
                    $(this.getMoveView.el).before(view.render().el);
                }, this);
            } else {
                if(this.getFilterString() == ""){
                    $(this.getMoveView.el).before(this.noResultsTemplate);
                } else {
                    $(this.getMoveView.el).before(this.noFilterResultsTemplate);
                }

            }
            if(this.model.get(this.hasMoreAttr)){
                this.getMoveView.removeLoader();
            } else {
                this.getMoveView.unbind();
                this.getMoveView.remove();
            }

        },
        getAdditionalViews:function(){
            return [];
        },
        getGetMoreView:function(){
            return null;
        },

        /* Base Filtering Functions */
        querySearch:function(event) {
            event.stopPropagation();
            var inp = String.fromCharCode(event.keyCode);
            if (/[a-zA-Z0-9-]/.test(inp) || event.keyCode == 8){
                this.procQuerySearch();
            }
        },
        getFilterString:function(){
            var returnVal = "";
            if(this.filterSelector != ''){
               // returnVal = this.$(this.filterSelector).val().trim();
            }
            return returnVal;
        },
        procQuerySearch:function(){
            var newQuery = this.getFilterString();
            if(this.query != newQuery){
                this.query = newQuery;
                if(this.query == ""){
                    this.model.query = undefined;
                }else{
                    this.model.query = newQuery;
                }
                window.setTimeout(
                    $.proxy(
                        this.procTimeBuildQuerySearch,
                        this, newQuery),
                    800);
            }
        },
        procTimeBuildQuerySearch:function(val){
            if(val == this.getFilterString()){
                this.model.page = 1;
                this.fetchModel();
            }
        },
        clearSearch:function(){
            this.$(this.filterSelector).val("");
            this.model.query = undefined;
            this.fetchModel();
        }
    });
    return LazyPagingView;
});

